import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onCreateRole,
  onDeleteRole,
  onGetAllPermissions,
  onGetAllRoles,
  onGetRole,
  onGetRoleForEdit,
  onGetRolesAsync,
  onUpdateRole,
} from '../../../app/modules/base-definitions/components/roles/core/_request'

interface RoleState {
  roles: any
  role: any
  mappedPermissions: any
  isLoading: boolean
}

const initialState = {
  roles: [],
  role: null,
  isLoading: true,
  mappedPermissions: [],
} as RoleState

export const createRole = createAsyncThunk('role/createRole', async (param: any) => {
  const data: any = await onCreateRole(param)
  return data.data
})

export const fetchRolesAsync = createAsyncThunk('role/fetchRolesAsync', async (param: any) => {
  const data: any = await onGetRolesAsync(param)
  return data.data.result
})

export const updateRole = createAsyncThunk('role/updateRole', async (param: any) => {
  const data: any = await onUpdateRole(param)
  return data.data
})

export const deleteRole = createAsyncThunk('role/deleteRole', async (param: any) => {
  const data: any = await onDeleteRole(param)
  return data.data
})

export const fetchPermissions = createAsyncThunk('role/fetchPermissions', async () => {
  const data: any = await onGetAllPermissions()
  return data.data.result
})

export const fetchRoleForEdit = createAsyncThunk('role/fetchRoleForEdit', async (param: any) => {
  const data: any = await onGetRoleForEdit(param)
  return data.data.result
})

export const fetchRole = createAsyncThunk('role/fetchRole', async (param: any) => {
  const data: any = await onGetRole(param)
  return data.data.result
})

export const fetchRoles = createAsyncThunk('role/fetchRoles', async (param: any) => {
  const data: any = await onGetAllRoles(param)
  return data.data.result
})

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    clearRoles: (state) => {
      state.roles = []
    },
    clearRole: (state) => {
      state.role = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
    setMappedPermissions: (state, action) => {
      state.mappedPermissions = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRoles.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchRoles.fulfilled, (state: any, action) => {
      state.roles = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchRoles.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchPermissions.fulfilled, (state: any, action) => {
      state.permissions = action.payload
    })
    builder.addCase(fetchRoleForEdit.fulfilled, (state: any, action) => {
      state.role = action.payload
    })
  },
})

export const {clearRoles, clearRole, activateLoading, setMappedPermissions} = roleSlice.actions

export default roleSlice.reducer
